import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'
import Rating from 'components/Rating'
import Typography from 'components/Typography'
import useViewport from 'hooks/useViewport'
import Slider from 'screens/listingDetail/components/RichContent/components/Slider'

import classes from './UserInteface.module.scss'

/** @type {import("./types").default} */
const UserInteface = ({ className, numReviews, ratingAvg }) => {
  const { up } = useViewport()
  const isDesktop = up('lg')
  return (
    <Grid className={clsx('UserInteface', className)}>
      <Grid item xs={12} className={classes.sectionTitleWrapper}>
        <Typography component="span" className={classes.sectionTitle}>
          Ease of use rating:
        </Typography>
        <Rating.Link average={ratingAvg} totals={numReviews} isCompact size="small" />
      </Grid>

      <Slider variant={isDesktop ? 'vertical' : 'horizontal'} className={classes.screenshots} />
    </Grid>
  )
}

export default UserInteface
